import React, { useEffect, useMemo, useState } from 'react';
import { I18n } from 'aws-amplify';
import { Row, Col, Accordion, Form, Button } from 'react-bootstrap';

import { ACTIVE } from './../../shared/constants/index';


export const VersionFilter= (props) => {

  // props を分解（lint対策：依存に props 全体を入れない）
  const {
    filter: setFilter,
    nextToken: setNextToken,
    nextRead: setNextRead,
    load,
    series = 'all',      // 'all' | 'v1' | 'v2'
    setSeries,
    defaultOpen = false,
  } = props;

    // UserFilter と同じ「初期条件」
  const defaultFilter = { active: true };

  // 入力状態
  const [active, setActive]   = useState(ACTIVE.ON);
  const [localSeries, setLocalSeries] = useState(series || 'all'); // 'all' | 'v1' | 'v2'

  // ラジオリスト
  const activeList = [
    { name: 'general_unselected', value: ACTIVE.NONE },
    { name: 'general_active',     value: ACTIVE.ON },
    { name: 'general_inactive',   value: ACTIVE.OFF },
  ];

    // 追加読み込みを封じる
  const invalidate = () => {
    setNextToken(null);
    setNextRead(false);
  };

  // 入力バインド共通
  const bind = (setter) => (e) => {
    setter(e.target.value);
    invalidate();
  };

  // 送信条件をメモ化
  const criteria = useMemo(() => {
    const c = {};

    switch (active) {
      case ACTIVE.ON:
        c['active'] = true;
        break;
      case ACTIVE.OFF:
        c['active'] = false;
        break;
      case ACTIVE.NONE:
      default:
        break;
    }
    return c;
  }, [active]);

  // クリア
  const clear = () => {
    setActive(ACTIVE.ON);
    setLocalSeries('all');

    invalidate();
    setFilter(defaultFilter);
    if (typeof setSeries === 'function') setSeries('all');
  };

  // 適用
  const executeFilter = () => {
    const isEmpty = Object.keys(criteria).length === 0;
    // 空のときも {} を渡して「前回nullでも変更扱い」にする
    setNextToken(null);
    setNextRead(false);
    setFilter(isEmpty ? {} : criteria);
    if (typeof setSeries === 'function') setSeries(localSeries);
  };

  // 初回マウント時に一度だけ適用（UserFilterと同じ設計）
  useEffect(() => {
    executeFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Row>
        <Col xs={12} md={12} className="mt-1">
          <Accordion defaultActiveKey={defaultOpen ? '0' : undefined}>
            <Accordion.Item eventKey="0">
              <Accordion.Header bsPrefix="accordion-button-custom">
                {I18n.get('general_filter')}{' '}
              </Accordion.Header>

              <Accordion.Body>
                {/* Active: ラジオ（UserFilterの見た目に揃える） */}
                <Row className="mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-state">
                      <Form.Label column sm={4}>{I18n.get('general_status')}</Form.Label>
                      <Col sm={8}>
                        {activeList.map((radio, idx) => (
                          <Form.Check
                            key={`vf-${idx}`}
                            className="toggleButtonInline"
                            inline
                            disabled={load}
                            id={`vf-radio-state-${idx}`}
                            type="radio"
                            name="vf-state-group"
                            value={radio.value}
                            checked={active === radio.value}
                            label={I18n.get(radio.name)}
                            onChange={(e) => { setActive(e.currentTarget.value); invalidate(); }}
                          />
                        ))}
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} />
                </Row>

                {/* v1 / v2 / すべて */}
                <Row className="mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-series">
                      <Form.Label column sm={4}>
                        {I18n.get('label_version_series') || 'Series'}
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Select
                          value={localSeries}
                          onChange={bind(setLocalSeries)}
                          disabled={load}
                        >
                          <option value="all">すべて（v1/v2）</option>
                          <option value="v1">v1 系のみ</option>
                          <option value="v2">v2 系のみ</option>
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} />
                </Row>

                {/* ボタン行（UserFilterと同配置） */}
                <Row>
                  <Col xs={12} md={12} className="mt-1">
                    <div className="text-end">
                      <Button
                        variant="secondary"
                        disabled={load}
                        style={{ marginRight: '5px' }}
                        onClick={clear}
                      >
                        {I18n.get('general_clear')}
                      </Button>{' '}
                      <Button variant="primary" disabled={load} onClick={executeFilter}>
                        {I18n.get('general_apply')}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </>
  );
};
